import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  id: "sign_up",
  class: "mb-3"
}
const _hoisted_2 = { class: "row mb-3" }
const _hoisted_3 = { class: "col-12 col-md-6 mb-3" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label",
  for: "business_name"
}, "Business name", -1)
const _hoisted_5 = { class: "col-12 col-md-6 mb-3" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label",
  for: "website"
}, [
  /*#__PURE__*/_createTextVNode(" Website "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-muted fs-7" }, "(optional)")
], -1)
const _hoisted_7 = { class: "col-12 col-md-6 mb-3" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label",
  for: "contact_first_name"
}, " Your first name ", -1)
const _hoisted_9 = { class: "col-12 col-md-6 mb-3" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label",
  for: "contact_last_name"
}, "Your last name", -1)
const _hoisted_11 = { class: "col-12 col-md-6 mb-3" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label",
  for: "contact_phone"
}, " Your cell phone number ", -1)
const _hoisted_13 = { class: "col-12 col-md-6 mb-3" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label",
  for: "contact_email"
}, "Your email", -1)
const _hoisted_15 = {
  key: 0,
  class: "col-12 mb-3"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label",
  for: "about_akko"
}, " How did you hear about AKKO? ", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("option", {
  value: "",
  selected: "",
  disabled: ""
}, "Select an Option", -1)
const _hoisted_18 = ["value"]
const _hoisted_19 = {
  key: 1,
  class: "col-12 mb-3"
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label",
  for: "about_akko_distributor"
}, "Which one?", -1)
const _hoisted_21 = {
  key: 2,
  class: "col-12 mb-3"
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label",
  for: "about_akko_other"
}, "Please Specify Other", -1)
const _hoisted_23 = {
  key: 3,
  class: "col-12 mb-3"
}
const _hoisted_24 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label",
  for: "country"
}, " Country ", -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("option", {
  value: "",
  selected: "",
  disabled: ""
}, "Select an Option", -1)
const _hoisted_26 = ["value"]
const _hoisted_27 = {
  key: 4,
  class: "col-12 mb-3"
}
const _hoisted_28 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label",
  for: "country"
}, " Partner Type ", -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("option", {
  value: "",
  selected: "",
  disabled: ""
}, "Select an Option", -1)
const _hoisted_30 = ["value"]
const _hoisted_31 = { class: "col-12 mb-3" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label",
  for: "referral_code"
}, "Referral code", -1)
const _hoisted_33 = { class: "row" }
const _hoisted_34 = { class: "col-12" }
const _hoisted_35 = {
  key: 0,
  class: "alert alert-danger",
  role: "alert"
}
const _hoisted_36 = { class: "d-grid" }
const _hoisted_37 = ["disabled"]
const _hoisted_38 = /*#__PURE__*/_createElementVNode("p", { class: "mt-4 text-center fs-8 text-decoration-none" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://getakko.com/legal",
    target: "_blank"
  }, "Terms and Conditions")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_InputMask = _resolveComponent("InputMask")!
  const _component_SpinnerLoading = _resolveComponent("SpinnerLoading")!
  const _component_Form = _resolveComponent("Form")!
  const _component_AuthLayout = _resolveComponent("AuthLayout")!

  return (_openBlock(), _createBlock(_component_AuthLayout, { css: "signup-form" }, {
    default: _withCtx(() => [
      _createVNode(_component_Form, {
        onSubmit: _ctx.onSubmit,
        "validation-schema": _ctx.validationSchema
      }, {
        default: _withCtx(({ errors, meta, isSubmitting, setFieldValue }) => [
          _createElementVNode("fieldset", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _hoisted_4,
                _createVNode(_component_Field, {
                  class: _normalizeClass(["form-control", _ctx.isInvalid(errors, 'business_name')]),
                  name: "business_name",
                  id: "business_name",
                  type: "text"
                }, null, 8, ["class"]),
                _createVNode(_component_ErrorMessage, {
                  class: "invalid-feedback",
                  name: "business_name"
                })
              ]),
              _createElementVNode("div", _hoisted_5, [
                _hoisted_6,
                _createVNode(_component_Field, {
                  class: _normalizeClass(["form-control", _ctx.isInvalid(errors, 'website')]),
                  name: "website",
                  id: "website",
                  type: "text"
                }, null, 8, ["class"]),
                _createVNode(_component_ErrorMessage, {
                  class: "invalid-feedback",
                  name: "website"
                })
              ]),
              _createElementVNode("div", _hoisted_7, [
                _hoisted_8,
                _createVNode(_component_Field, {
                  class: _normalizeClass(["form-control", _ctx.isInvalid(errors, 'contact_first_name')]),
                  name: "contact_first_name",
                  id: "contact_first_name",
                  type: "text"
                }, null, 8, ["class"]),
                _createVNode(_component_ErrorMessage, {
                  class: "invalid-feedback",
                  name: "contact_first_name"
                })
              ]),
              _createElementVNode("div", _hoisted_9, [
                _hoisted_10,
                _createVNode(_component_Field, {
                  class: _normalizeClass(["form-control", _ctx.isInvalid(errors, 'contact_last_name')]),
                  name: "contact_last_name",
                  id: "contact_last_name",
                  type: "text"
                }, null, 8, ["class"]),
                _createVNode(_component_ErrorMessage, {
                  class: "invalid-feedback",
                  name: "contact_last_name"
                })
              ]),
              _createElementVNode("div", _hoisted_11, [
                _hoisted_12,
                _createVNode(_component_Field, {
                  name: "contact_phone",
                  modelValue: _ctx.phoneMaskedValue,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.phoneMaskedValue = $event))
                }, {
                  default: _withCtx(({ meta: m }) => [
                    _createVNode(_component_InputMask, {
                      class: _normalizeClass(["form-control", m.valid === false && _ctx.isInvalid(errors, 'contact_phone')]),
                      modelValue: _ctx.phoneMaskedValue,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.phoneMaskedValue = $event)),
                      onChange: ($event: any) => (setFieldValue('contact_phone', _ctx.phoneMaskedValue)),
                      mask: "(999) 999-9999",
                      unmask: true,
                      type: "tel",
                      autocomplete: "newphone"
                    }, null, 8, ["class", "modelValue", "onChange"])
                  ]),
                  _: 2
                }, 1032, ["modelValue"]),
                _createVNode(_component_ErrorMessage, {
                  class: "invalid-feedback",
                  name: "contact_phone"
                })
              ]),
              _createElementVNode("div", _hoisted_13, [
                _hoisted_14,
                _createVNode(_component_Field, {
                  class: _normalizeClass(["form-control", _ctx.isInvalid(errors, 'contact_email')]),
                  name: "contact_email",
                  id: "contact_email",
                  type: "text"
                }, null, 8, ["class"]),
                _createVNode(_component_ErrorMessage, {
                  class: "invalid-feedback",
                  name: "contact_email"
                })
              ]),
              (_ctx.partnerProgram === _ctx.AKKO_PROGRAM)
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    _hoisted_16,
                    _createVNode(_component_Field, {
                      class: _normalizeClass(["form-select", _ctx.isInvalid(errors, 'about_akko')]),
                      name: "about_akko",
                      id: "about_akko",
                      as: "select",
                      modelValue: _ctx.aboutAkko,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.aboutAkko = $event))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_17,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.aboutAkkoOptions, (opt) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: opt.id,
                            value: opt.id
                          }, _toDisplayString(opt.text), 9, _hoisted_18))
                        }), 128))
                      ]),
                      _: 2
                    }, 1032, ["class", "modelValue"])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.aboutAkko === _ctx.ABOUT_AKKO_DESTRIBUTOR_ID)
                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                    _hoisted_20,
                    _createVNode(_component_Field, {
                      class: _normalizeClass(["form-control", _ctx.isInvalid(errors, 'about_akko_distributor')]),
                      name: "about_akko_distributor",
                      id: "about_akko_distributor",
                      type: "text"
                    }, null, 8, ["class"]),
                    _createVNode(_component_ErrorMessage, {
                      class: "invalid-feedback",
                      name: "about_akko_distributor"
                    })
                  ]))
                : _createCommentVNode("", true),
              (_ctx.aboutAkko === _ctx.ABOUT_AKKO_OTHER_ID)
                ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                    _hoisted_22,
                    _createVNode(_component_Field, {
                      class: _normalizeClass(["form-control", _ctx.isInvalid(errors, 'about_akko_other')]),
                      name: "about_akko_other",
                      id: "about_akko_other",
                      type: "text"
                    }, null, 8, ["class"]),
                    _createVNode(_component_ErrorMessage, {
                      class: "invalid-feedback",
                      name: "about_akko_other"
                    })
                  ]))
                : _createCommentVNode("", true),
              (_ctx.partnerProgram === _ctx.AKKO_PROGRAM)
                ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                    _hoisted_24,
                    _createVNode(_component_Field, {
                      class: _normalizeClass(["form-select", _ctx.isInvalid(errors, 'country')]),
                      name: "country",
                      id: "country",
                      as: "select"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_25,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.countryOptions, (opt) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: opt.id,
                            value: opt.id
                          }, _toDisplayString(opt.text), 9, _hoisted_26))
                        }), 128))
                      ]),
                      _: 2
                    }, 1032, ["class"])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.partnerProgram === _ctx.AKKO_PROGRAM)
                ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                    _hoisted_28,
                    _createVNode(_component_Field, {
                      class: _normalizeClass(["form-select", _ctx.isInvalid(errors, 'partner_type')]),
                      name: "partner_type",
                      id: "partner_type",
                      as: "select"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_29,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.partnerTypeOptions, (opt) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: opt.id,
                            value: opt.id
                          }, _toDisplayString(opt.friendly_text), 9, _hoisted_30))
                        }), 128))
                      ]),
                      _: 2
                    }, 1032, ["class"])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_31, [
                _hoisted_32,
                _createVNode(_component_Field, {
                  class: _normalizeClass(["form-control", _ctx.isInvalid(errors, 'referral_code')]),
                  name: "referral_code",
                  id: "referral_code",
                  type: "text"
                }, null, 8, ["class"]),
                _createVNode(_component_ErrorMessage, {
                  class: "invalid-feedback",
                  name: "referral_code"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_33, [
              _createElementVNode("div", _hoisted_34, [
                (_ctx.error)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_35, _toDisplayString(_ctx.errorMesage), 1))
                  : _createCommentVNode("", true),
                isSubmitting
                  ? (_openBlock(), _createBlock(_component_SpinnerLoading, { key: 1 }))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_36, [
                  (!isSubmitting)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        type: "submit",
                        disabled: !meta.dirty,
                        class: "btn btn-lg btn-primary"
                      }, " Sign up ", 8, _hoisted_37))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ])
        ]),
        _: 1
      }, 8, ["onSubmit", "validation-schema"]),
      _hoisted_38
    ]),
    _: 1
  }))
}